/**
 * Switch this to contentful
 * Workout a re-usable promotion model
 */
export default {
  img: 'https://assets.bungalow.com/illustrations/full-color/happy-home.png',
  path: '/love-where-you-live-trial-terms',
  chip: '30-Day Trial',
  shortTitle: 'Love Where You Live',
  title: 'Love Where You Live 30-Day Trial',
  banner: 'Love where you live—guaranteed.',
  shortDescription: `We’re confident that you’ll love your new home! Still, we understand that every situation is unique. You have options if you decide it’s not the right fit within 30 days of your move-in date. Transfer to another available Bungalow home.<sup>*</sup>`,
  fullDescription: `At Bungalow, we’re confident that you’ll love your new home and roommates! Still, we understand that every situation is unique. You have options if you decide it’s not the right fit within 30 days of your move-in date. Transfer to another available Bungalow home and find your perfect fit.<sup>*</sup>`,
  footer: `*Terms and conditions apply, <br/><span class="font-bold blue-80--txt">See them here!</span>`,
}
